module.exports = __webpack_public_path__ + "static/media/faitrade-mobile.0f6fd618.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cta/faitrade-mobile.jpg
// module id = 377
// module chunks = 0